import { useState, useEffect } from "react";
import StepWrapper from "@/components/steps/StepWrapper";
import useQuizStore from "@/store/useQuizStore";

const LoadingStep = ({ step }) => {
  const { goToNext, loadingSteps } = useQuizStore();
  const [completedSteps, setCompletedSteps] = useState([]);
  const [activeStep, setActiveStep] = useState(0);
  const [revealedSteps, setRevealedSteps] = useState([0]);

  useEffect(() => {
    const timers = [];

    loadingSteps.forEach((_, index) => {
      if (index === 0) {
        setActiveStep(0);

        timers.push(
          setTimeout(() => {
            setCompletedSteps((prev) => [...prev, 0]);
            setRevealedSteps((prev) => [...prev, 1]);
            setTimeout(() => setActiveStep(1), 200);
          }, 1800),
        );
      } else if (index < loadingSteps.length) {
        timers.push(
          setTimeout(() => {
            setCompletedSteps((prev) => [...prev, index]);
            if (index + 1 < loadingSteps.length) {
              setRevealedSteps((prev) => [...prev, index + 1]);
              setTimeout(() => setActiveStep(index + 1), 200);
            }
          }, loadingSteps[index].delay + 1800),
        );
      }
    });

    timers.push(
      setTimeout(() => {
        goToNext();
      }, 8000),
    );

    return () => timers.forEach(clearTimeout);
  }, [goToNext, loadingSteps]);

  return (
    <StepWrapper title={step.title} subtitle={step.subtitle} noPadding>
      <div className="flex flex-col gap-2 md:gap-2.5">
        {loadingSteps.map((loadingItem, index) => {
          const isRevealed = revealedSteps.includes(index);
          const isActive =
            activeStep === index && !completedSteps.includes(index);
          const isCompleted = completedSteps.includes(index);

          return (
            <div
              key={index}
              className={`
                relative overflow-hidden bg-white rounded-[14px] md:rounded-xl font-medium
                transition-opacity duration-300
                ${
                  index === 0
                    ? "opacity-60"
                    : isRevealed
                      ? "opacity-60 animate-fade-in"
                      : "opacity-0 translate-y-[25px]"
                }
                ${isActive ? "opacity-100" : ""}
                ${isCompleted ? "opacity-100" : ""}
              `}
            >
              <div
                className={`
                  absolute top-0 left-0 h-full bg-[#FFFEEF] z-[5]
                  transition-[width] duration-[1500ms] ease-out
                  ${isActive ? "w-full" : isCompleted ? "w-full" : "w-0"}
                `}
                style={{ transitionDuration: isCompleted ? "0ms" : "1500ms" }}
              />

              <div className="relative z-10 flex items-center justify-between px-3.5 md:px-5 py-3 md:py-[1.4rem] min-h-[54px] md:min-h-[60px] bg-transparent">
                <span className="text-[0.95rem] md:text-base">
                  {loadingItem.text}
                </span>

                <div className="flex items-center justify-center w-5 h-5 md:w-6 md:h-6 relative">
                  <div
                    className={`
                      absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
                      w-5 h-5 md:w-6 md:h-6 rounded-full
                      flex items-center justify-center
                      transition-all duration-400 ease-[cubic-bezier(0.25,1.6,0.5,1)]
                      ${
                        isCompleted
                          ? "opacity-100 scale-100 rotate-0"
                          : "opacity-0 scale-[0.4] rotate-[-18deg]"
                      }
                    `}
                  >
                    <img
                      src={`${window.template_root}/src/public/img/check-circle.svg`}
                      alt="Complete"
                      className="w-5 h-5 md:w-6 md:h-6"
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </StepWrapper>
  );
};

export default LoadingStep;
